// src/pages/KyoteiLaw.tsx
import React from "react";
import Footer from "components/Footer";

export default function KyoteiLaw() {
  const Wrap: React.CSSProperties = {
    maxWidth: 720,
    margin: "0 auto",
    padding: "16px 14px 40px",
    lineHeight: 1.9,
    color: "#0b1a27",
    background: "#fff",
  };
  const H1: React.CSSProperties = {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "0.02em",
    margin: "22px 0 10px",
    color: "#1e73be",
  };
  const P: React.CSSProperties = { margin: "10px 0" };
  const UL: React.CSSProperties = { paddingLeft: 24, margin: "8px 0" };

  return (
    // 下付きフッター & body overflow対策
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f7fb",
        overflowY: "auto",
      }}
    >
      <main style={{ flex: 1 }}>

        <div style={Wrap}>
          <h1 style={H1}>モーターボート競走法に関する特記事項</h1>
          <p style={P}>
            当サイト「BOAT億MAN」は、モーターボート競走法その他関連法令を遵守し、
            違法な賭博行為やその助長を一切行いません。
            当サイトで提供する各種情報は、ボートレース（競艇）に関する予想・分析・情報提供を目的としたものであり、
            公営競技の主催者や公式機関とは一切関係ありません。
          </p>

          <h1 style={H1}>1. 予想情報について</h1>
          <p style={P}>
            当サイトが提供する予想・分析・助言などの情報は、ボートレースに関する統計的見地や独自解析によるものであり、
            その内容について的中・利益を保証するものではありません。
            利用者はご自身の判断・責任において舟券購入を行ってください。
          </p>

          <h1 style={H1}>2. 未成年者の利用禁止</h1>
          <p style={P}>
            モーターボート競走法第33条に基づき、20歳未満の方による舟券購入は法律で禁止されています。
            当サイトでは、20歳未満の方の利用および会員登録をお断りしています。
          </p>

          <h1 style={H1}>3. 公営競技主催者との関係</h1>
          <p style={P}>
            当サイトは、一般財団法人BOATRACE振興会、全国のボートレース場、
            および関係団体とはいかなる資本的・業務的関係も有しておりません。
            掲載内容はすべて独自の情報収集・分析結果に基づくものです。
          </p>

          <h1 style={H1}>4. 利用者の責任</h1>
          <p style={P}>
            本サービスの利用によって発生した損失や損害について、当サイトおよび運営事務局は一切の責任を負いません。
            舟券購入および関連行為は、すべて利用者の自己責任において行ってください。
          </p>

          <h1 style={H1}>5. 禁止事項</h1>
          <ul style={UL}>
            <li>予想情報・買い目の再配布、転売、転載、複製</li>
            <li>違法賭博行為やノミ行為などの犯罪への関与</li>
            <li>誤認を誘発する広告・虚偽の表現による勧誘</li>
          </ul>

          <h1 style={H1}>6. 表現および注意書き</h1>
          <p style={P}>
            当サイトに掲載される利益・回収率・的中率などの数値や表現は、
            将来の成果を保証するものではありません。
            すべての情報は参考資料として提供しています。
          </p>

          <h1 style={H1}>7. お問い合わせ</h1>
          <p style={P}>
            本特記事項に関するお問い合わせは、「お問い合わせ」ページ、
            またはサイト内フォームよりご連絡ください。
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
